/* Index_object_stores_media_marquee */
initMarquee('.Index_object_stores_media_marquee', {
    mobile: {
        duration: 40000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});
/* Index_object_stores_media_marquee */